<template>
  <div>
    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto" v-if="agendaSettings.showPDFButton">
        <md-button
          @click.prevent="print"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Download PDF')}}</md-button>
      </div>
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <md-field class="md-form-group md-layout-item md-size-100">
        <label>{{ $t('Search') }}</label>
        <md-input v-model="filters.search" v-on:keyup.enter="loadData(false)" />
      </md-field>

      <md-field class="md-form-group md-layout-item md-size-100 md-small-size-100">
        <label for="f_type">{{$t('Type')}}</label>
        <md-select v-model="filters.panelType" name="f_type" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.panelTypes" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>

      <!--
      <div class="md-layout-item md-size-5 md-small-hide" />
      <md-field class="md-form-group md-layout-item md-size-50 md-small-size-100">
        <label for="f_room">{{$t('Room')}}</label>
        <md-select v-model="filters.room" name="f_room" md-dense>
          <md-option>{{$t('Show all')}}</md-option>
          <md-option v-for="v in lookups.rooms" :key="v" :value="v">{{v}}</md-option>
        </md-select>
      </md-field>
      -->
    </div>

    <div class="md-layout md-layout-item md-size-100">
      <div class="ml-auto">
        <md-button
          @click="loadData(false);"
          class="md-round md-primary md-sm md-blue-border"
          style="margin:0px"
        >{{$t('Search')}}</md-button>
      </div>
    </div>

    <tabs
      :tab-active="1"
      :tab-name="dates"
      :tab-title="tabTitles"
      plain
      color-button="primary"
      @onChange="onTabChanged"
    >
      <div
        v-for="(date, index) in dates"
        :key="date"
        :slot="getTabName(index+1)"
        style="margin-top:32px"
      >
        <item :items="items" @selectedItem="e => $emit('selectedItem', e)" />
      </div>
    </tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "@/util/axios";
import { Tabs } from "@/components";
import Item from "./ThematicPaths.vue";

export default {
  components: { Tabs, Item },
  props: ["dates"],
  data() {
    return {
      items: [],
      filters: {},
      lookups: {
        rooms: [],
        panelTypes: []
      }
    };
  },
  computed: {
    ...mapGetters({
      conference: "conference/current",
      language: "language/current",
      agendaSettings: "user/agendaSettings"
    }),
    tabTitles: function() {
      return this.dates.map((d, i) =>
        this.agendaSettings.showDate
          ? `${this.$t("Day")} ${i + 1} (${this.$moment(d).format(
              "YYYY-MM-DD"
            )})`
          : `${this.$t("Day")} ${i + 1}`
      );
    }
  },
  methods: {
    async loadLookups() {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        this.lookups = (
          await axios.get("public/panels/lookups", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    async loadData(reload) {
      let loader = this.$loading.show({ container: this.$refs.page });
      try {
        if (reload) {
          await this.loadLookups();
        }

        var parsedFilters = { ...this.filters };

        parsedFilters.thematicPath = !!parsedFilters.thematicPath
          ? parsedFilters.thematicPath
          : null;
        parsedFilters.panelType = !!parsedFilters.panelType
          ? parsedFilters.panelType
          : null;
        parsedFilters.room = !!parsedFilters.room ? parsedFilters.room : null;

        this.items = (
          await axios.get("public/panels", {
            params: {
              year: this.conference.year,
              type: this.conference.type,
              language: this.language.code,
              ...parsedFilters,
              showAll: false
            }
          })
        ).data;
      } finally {
        this.loaded = true;
        loader.hide();
      }
    },
    getTabName(index) {
      return "tab-pane-" + index + "";
    },
    async onTabChanged(key) {
      this.filters.date = key;
      await this.loadData(true);
    },
    async print() {
      let loader = this.$loading.show({ container: this.$refs.page });

      try {
        await axios.downloadAgendaFile(
          "public/conferences/conference/printAgenda",
          {
            year: this.conference.year,
            type: this.conference.type,
            language: this.language.code
          }
        );
      } finally {
        loader.hide();
      }
    }
  },
  watch: {
    async conference() {
      await this.loadData(true);
    },
    async language() {
      this.items = [];
      await this.loadData(true);
    }
  },
  async mounted() {
    this.filters.date = this.dates[0];
    await this.loadData(true);
  }
};
</script>
<style lang="scss" scoped>
.info {
  .icon > i {
    font-size: 2.5rem !important;
  }
  .info-title {
    margin: 1rem;
  }
}
</style>